import {
  DialogModalAction,
  DialogModalActions,
  DialogModalCancel,
  DialogModalCloseButton,
  DialogModalContent,
  DialogModalFooter,
  DialogModalHeader,
  DialogModalRoot,
  DialogModalTitle,
} from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IDeleteMessageModalProps {
  onClose(): void;
  onDelete(): void;
}

export const DeleteMessageModal: React.FC<IDeleteMessageModalProps> = ({ onClose, onDelete }) => {
  return (
    <DialogModalRoot
      open
      onOpenChange={open => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogModalContent size="S">
        <DialogModalCloseButton
          size="XS"
          theme="fill_light"
          title="Закрыть"
          icon={<IconActionClose12 color="current_color" />}
        />

        <DialogModalHeader>
          <DialogModalTitle>Вы действительно хотите удалить сообщение?</DialogModalTitle>
        </DialogModalHeader>

        <DialogModalFooter>
          <DialogModalActions>
            <DialogModalCancel onClick={onClose} size="M">
              Отмена
            </DialogModalCancel>
            <DialogModalAction onClick={onDelete} size="M">
              Удалить
            </DialogModalAction>
          </DialogModalActions>
        </DialogModalFooter>
      </DialogModalContent>
    </DialogModalRoot>
  );
};
